import { WorksheetStore, WorksheetWordStore } from '@seedlang/stores';

export async function loadWorksheetWordIds({ worksheetId, filters, sort }, isCancelled = () => false) {
  if (isCancelled()) return [];
  let resolvedWorksheetId = worksheetId;
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(worksheetId)) {
    const worksheetStore = new WorksheetStore.constructor();
    const worksheet = await new Promise((resolve, reject) => {
      worksheetStore.getShow({ ids: { worksheetId } }, resolve, {
        failureCallback: reject,
        onRequestError: reject,
        timeout: 15000,
      });
    });
    if (isCancelled()) return [];
    if (!worksheet?.id) throw new Error('Worksheet not found');
    resolvedWorksheetId = worksheet.id;
  }
  const store = new WorksheetWordStore.constructor();
  const wordIds = new Set();
  const limit = 100;
  let loaded = 0;
  for (let page = 1; !isCancelled(); page += 1) {
    store.setPage(page);
    const response = await new Promise((resolve, reject) => {
      store.getIndex({
        ids: { worksheetId: resolvedWorksheetId },
        filters,
        sort,
        limit,
        failureCallback: reject,
        onRequestError: reject,
        timeout: 15000,
      }, resolve);
    });
    if (isCancelled()) return [];
    store.setIndexData(response);
    store.indexData.forEach(item => {
      if (!item.invalid && item.word?.id) wordIds.add(item.word.id);
    });
    loaded += store.indexData.length;
    if (!store.indexData.length || (store.totalCount != null
      ? loaded >= store.totalCount
      : store.indexData.length < limit)) break;
  }
  return [...wordIds];
}
